// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"50":"css/client","51":"css/contact-us","102":"css/forum-single","170":"css/app","177":"css/forum","265":"css/news","272":"css/opportunities-single","291":"css/news-single","332":"css/about-us","381":"css/events-single","449":"css/home","496":"css/opportunities","703":"css/admin","726":"css/events"}[chunkId] + ".css";
};